export enum PolicyStatus {
  Active = "Active",
  Expired = "Expired",
  Cancelled = "Cancelled",
  Refunded = "Refunded",
  Lapsed = "Lapsed"
}

export const POLICY_STATUS_LABEL_MAP = {
  [PolicyStatus.Active]: "Active",
  [PolicyStatus.Expired]: "Expired",
  [PolicyStatus.Cancelled]: "Cancelled",
  [PolicyStatus.Refunded]: "Refunded",
  [PolicyStatus.Lapsed]: "Lapsed"
}

export function getPolicyStatusLabel(policyStatus: string): string {
  return POLICY_STATUS_LABEL_MAP[policyStatus] || "";
}

export function getPolicyStatusList(): string[] {
  return Object.keys(POLICY_STATUS_LABEL_MAP);
}